export const seoKeywords = {
  name: 'keywords',
  content:
    'Defi development company, decentralized finance development, defi product development, custom defi app, custom defi product, defi development, web3 development services, defi developers to hire',
};

export const deFiDevelopmentPageSeo = {
  title: 'Decentralized Finance Software Development Services | Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        "Our experienced full-stack blockchain developers will take your DeFi solution to the next level - we stay on top of the newest technologies, trends, and tools to make sure your DeFi product is perfectly tailored to your customers' needs and desires. DeFi platform development with the Rumble Fish team is your key to success!",
    },
  ],
};
